'use strict';

import { changeLangToCurrent, getCurrentLang, getLanguagesTranslations } from '../components/langSwitcher/langSwitcher';
import {
  addFloorOrdinalSuffix,
  findSelectionAndCrmData, getFieldsFromAPI,
  getObjectFromLocalStorage, getUrlParam,
  handleFavoriteLogic,
  isCompareMode, isNumeric, numberWithCommas,
} from '../../functions';
import {Buildings, cardsData, components, isDesktop, isMobile, isNoMenu, isWeb, settingsData} from "../../settings";
import { removeOptionCardListeners } from './optionsCards';
import { Prepayment} from "../components/Prepayment/Prepayment";
import {
  closeOptionsCardAnimation,
} from "./cardsAnimation";
import {CardTypes, ViewMode} from "../../common";
import {dataArrayOfFlat, facingDictionary} from "./cardsConfig";
import {renderUpdateValuesOnDemand} from "../../app";
import {selectionBoxesSetStatusColor} from "../threejs/raycast";
import {setLordIcon} from '../../lordicon';
import { addBmbyEditButton, getPropType } from './unitCards/unitCardFunctions';
import {closeNotifications} from '../analytics/statistic';
import { CustomerContactNow } from '../menu/contactUs/CustomerContactNow';
import {BaseElement} from "../interfaces/BaseElement";
import {showAsideContainer} from "../menu/menu";
import { Price } from './Price';
import {setSearchContainerMaxHeight} from "../menu/search/search";
import {StaticPrepayment} from "../components/StaticPrepayment";
import {UnitCardClass} from "./unitCards/UnitCardClass";
import {Amenities} from "../components/Amenities/Amenities";

export const closeOptionsCard = () => {
  renderUpdateValuesOnDemand(false);
  closeNotifications();
  removeOptionCardListeners();
  closeOptionsCardAnimation();
  if (!isMobile) {
    document.querySelector('#threejs > .disclaimer')?.classList.remove('hidden');
    UnitCardClass.cards.forEach(card => card.html.classList.remove('hidden'));
  }

  cardsData.cardMode.isUnavailable = false;
  if (isWeb && !isNoMenu) {
    const searchMainContainer = document.querySelector('.search__container-main');
    if (searchMainContainer)
      searchMainContainer.style.marginInlineStart = '56px';
    const menu = document.querySelector('.aside__container');
    if (menu)
      menu.style.position = 'fixed';
    setSearchContainerMaxHeight();
  }

  if (isNoMenu)
    document.querySelector('.button-modes--back[data-button="back"]')?.classList.remove('hidden');

  if (cardsData.cardMode.isAmenities) {
    if (settingsData.lastClickedFlat) {
      settingsData.lastClickedFlat.userData.isClicked = false;
      selectionBoxesSetStatusColor(settingsData.lastClickedFlat, 'hoverOut');
    }
    cardsData.cardMode.isAmenities = false;
  }

  if (isMobile) {
    // toggleCardMainButton();
    document.querySelector('.additional-menu__container')?.classList.remove('hidden');
    if (settingsData.isLandscape)
      document.querySelector('.amenities__main__container')?.classList.remove('hidden');
    components.mobileSearch?.show();
    const floorSlider = document.querySelector('.fs__main__container');
    floorSlider && floorSlider.classList.remove('hidden');
  }

  if (isDesktop)
    showAsideContainer();
}

export const createHeader = (...props) => {
  const [object, cardBoxWrapper, settings, card, resize] = props;

  const cardBoxHeader = new BaseElement()
    .addClass(`${card}-card__header`, 'card__header', `${settingsData.isConferenceHost && "conference"}`)
    .appendTo(cardBoxWrapper)
    .DOMElement;

  if (isCompareMode())
    cardBoxHeader.classList.add('compare-mode');

  const titleBox = new BaseElement()
    .addClass(`${card}-card__title-box`, 'card__title-box')
    .appendTo(cardBoxHeader)
    .DOMElement;
  const subTitleBox = new BaseElement()
    .addClass(`${card}-card__subtitle-box`, 'card__subtitle-box')
    .appendTo(titleBox)
    .DOMElement;

  addTitleBlock(titleBox,object);

  if (Buildings.getBuildingsInfoLength() > 1)
    addTowerName(subTitleBox, card, object);
  if (!Buildings.isOneFloorBuilding(object.buildingEngineId) || getUrlParam('card'))
    addFloor(object, subTitleBox, card);
  if (cardsData.cardMode.isAmenities)
    return;
  if (!isMobile && object.selectedProperty) {
    new BaseElement('span')
        .addClass(`${CardTypes.Options}-card__label`, 'card__label', 'selected-property')
        .addAttribute('data-dictionary', 'selectedProperty')
        .innerHtml(changeLangToCurrent('selectedProperty'))
        .appendTo(titleBox);
  }

  // Apply now
  if (card === CardTypes.Options && isMobile) {
    let prepaymentPosition;
    if (resize)
      prepaymentPosition = settingsData.isLandscape ? 'beforebegin' : null;

    const optionsCardBumper = document.querySelector(`.${CardTypes.Options}-card__bumper`);
    const cardButtonsWrapper = optionsCardBumper && new BaseElement()
      .addClass('cards-buttons-wrapper')
      .appendTo(optionsCardBumper);

    if (cardButtonsWrapper?.DOMElement && settingsData.isConferenceHost && !cardsData.cardMode.isAmenities)
      new StaticPrepayment(cardButtonsWrapper.DOMElement, object);
    if (!cardsData.cardMode.isAmenities && cardButtonsWrapper?.DOMElement)
      new Prepayment(cardButtonsWrapper.DOMElement,object,prepaymentPosition);
    if (cardButtonsWrapper?.DOMElement)
      new CustomerContactNow('option-card').appendTo(cardButtonsWrapper.DOMElement);

    if (cardButtonsWrapper)
      addBmbyEditButton(object,cardButtonsWrapper.DOMElement,CardTypes.Options);

    if (cardButtonsWrapper?.DOMElement.children.length === 0)
      cardButtonsWrapper.remove();
  }

  if (!cardsData.cardMode.isAmenities && !isMobile) {
    addPriceBlock(object, titleBox);
  } else if (card === CardTypes.Options && !cardsData.cardMode.isAmenities && isMobile) {
    addPriceBlock(object, cardBoxHeader);
  } else if (card === CardTypes.Unit && !cardsData.cardMode.isAmenities && isMobile) {
    addPriceBlock(object, titleBox);
  } else {
    addPriceBlock(object, titleBox);
  }
}

export const addTowerName = (parent, card, object) => {
  const buildingData = config.buildings.find(
    building => building.buildingEngineId === (object.buildingEngineId || object.buildingEngineID)
  );

  let towerName;
  Array.isArray(buildingData.buildingTitle) && buildingData.buildingTitle.length
    ? towerName = buildingData.buildingTitle.find(name => name.lang === getCurrentLang()).value
    : towerName = object.buildingName;

  const towerNameElement = new BaseElement()
    .addClass(`${card}-card__tower-name`, `card__tower-name`)
    .appendTo(parent)
    .DOMElement;
  if (!b.isOneFloorBuilding(object.buildingEngineId) || getUrlParam('card'))
    new BaseElement()
      .addClass('subtitle-separator')
      .appendTo(parent);

  if (isMobile && card === CardTypes.Options) {
    new BaseElement('span')
      .addClass(
        `${card}-card__floor-number-icon`,
        `card__floor-number-icon`,
        'icon-building',
      )
      .appendTo(towerNameElement);
  }

  applyTowerNameNamingRule(towerName, towerNameElement, card);
}

export const applyTowerNameNamingRule = (towerName, parent, cardType) => {
  const regExp = /[a-z\u0590-\u05fe]/gi;
  const isStringName = regExp.test(towerName);

  if (!isStringName) {
    new BaseElement('span')
        .addClass(`${cardType}-card__tower-name_num`, 'language-string')
        .addAttribute('data-dictionary', 'building')
        .innerHtml(changeLangToCurrent('building') + ' ')
        .appendTo(parent);
  }

  new BaseElement('span')
      .addClass(`${cardType}-card__tower-name_title`)
      .innerHtml(towerName + ' ')
      .appendTo(parent);
}

export const addFloor = (object, parent, card) => {
  const floorNumberElement = new BaseElement()
    .addClass(`${card}-card__floor-number`, `card__floor-number`)
    .appendTo(parent)
    .DOMElement;
  if (isMobile && card === CardTypes.Options) {
    new BaseElement('span')
      .addClass(
        `${card}-card__floor-number-icon`,
        `card__floor-number-icon`,
        'icon-floor',
      )
      .appendTo(floorNumberElement);
  }
  
  const isGroundFloor = settingsData.groundFloor.isActive && (parseInt(settingsData.groundFloor.floor) === parseInt(object.floorNum));
  const floorElement = new BaseElement('span')
    .addClass('language-string')
    .innerHtml(changeLangToCurrent('floor') + ' ')
    .appendTo(floorNumberElement);

  if (isGroundFloor) {
    const fullLabel = settingsData.groundFloor.fullLabel;
    floorElement
      .addAttribute('data-dictionary', fullLabel)
      .innerHtml(changeLangToCurrent(fullLabel));
  } else {
    const floorNumber = new BaseElement('span')
        .addClass(`${card}-card__floor-number_num`, 'card__floor-number_num', 'language-string', isGroundFloor ? 'hidden' : null)
        .innerHtml(object?.floorNum || object?.floor)
        .appendTo(floorNumberElement);
    
    const translationData = getLanguagesTranslations('floor');
    const currentLang = getCurrentLang();
    
    Object.entries(translationData).forEach(([lang,value]) => {
      let floorElementValue = value;
      let floorNumberValue = object?.floorNum || object?.floor;
      
      if (lang === 'en') {
        floorElementValue = addFloorOrdinalSuffix(floorNumberValue);
        floorNumberValue = ' ';
      }
      
      if (lang === currentLang) {
        floorElement.innerHtml(floorElementValue);
        floorNumber.innerHtml(floorNumberValue);
      }
      
      floorElement.addAttribute(`data-lang-${lang}`,floorElementValue);
      floorNumber.addAttribute(`data-lang-${lang}`,floorNumberValue);
    });
    
    
    
  }
}

export const addTitleBlock = (parentElement,object) => {
  const titleBlock = new BaseElement('h3')
    .addClass(`${CardTypes.Options}-card__title`, 'card__title')
    .appendTo(parentElement)
    .DOMElement;

  addApartmentNameWithNumber(titleBlock,object);
}

export function addApartmentNameWithNumber(parentElement,object) {
  const optionsCards = [...document.querySelectorAll(`.${CardTypes.Options}-card`)];
  const engineId = optionsCards.length === 1
    ? optionsCards[0].getAttribute('data-engineid')
    : optionsCards[1].getAttribute('data-engineid');

  const flatNameWrapper = new BaseElement()
      .addClass(`${CardTypes.Options}-card__flat-name-wrapper`, 'card__flat-name-wrapper')
      .appendTo(parentElement)
      .DOMElement;
  addFlatName(flatNameWrapper,object);

  new BaseElement('span')
      .addClass(`${CardTypes.Options}-card__title-flat-number`, 'card__title-flat-number')
      .innerHtml(!cardsData.cardMode.isAmenities ? findSelectionAndCrmData(engineId).crmDataOfFlat.propNum : '')
      .appendTo(flatNameWrapper);
}

const addFlatName = (parentElement,object) => {
  const lastClickedFlat = !cardsData.cardMode.isAmenities ? settingsData.lastClickedFlat.userData.crm_data : null;
  const flatNameValue = !cardsData.cardMode.isAmenities
    ? `${getPropType(lastClickedFlat.propType)}`
    : object?.propNum || object?.title;
  const flatNameText = !cardsData.cardMode.isAmenities
    ? `${changeLangToCurrent(getPropType(lastClickedFlat.propType))}`
    : `${changeLangToCurrent(object?.propNum || object?.title)}`;
  new BaseElement('span')
    .addClass(`${CardTypes.Options}-card__title-flat-name`, 'language-string', 'card__title-flat-name')
    .addAttribute('data-dictionary', flatNameValue)
    .innerHtml(flatNameText)
    .appendTo(parentElement)
}

export const addPriceBlock = (object, cardBox) => {
  if (cardsData.cardMode.isAmenities)
    return;

  new Price()
      .addBlock(cardBox)
      .setPrice(object);
}

export const addInfopointsBlock = (...props) => {
  const [object, cardBox, card, settings] = props;
  const infoPointsBlock = new BaseElement()
    .addClass(`${card}-card__info-points`, 'card__info-points')
    .appendTo(cardBox)
    .DOMElement;

  if (isCompareMode())
    infoPointsBlock.classList.add('compare-mode');
  if (!cardsData.cardMode.isAmenities)
    addFlatDataToUnitCard(object, infoPointsBlock, card, settings, cardBox);
}

export const addFlatDataToUnitCard = (object, infoPointsBlock, card) => {
  // info-points
  if (card === 'compare')
    return;

  const price = new Price();
  const cardsInfo = dataArrayOfFlat(object);
  const infoPointsData = cardsInfo.filter(data => {
    if (card === CardTypes.Unit && getFieldsFromAPI.smallCard().indexOf(data.name) !== -1) {
      return data;
    } else if (card === CardTypes.Options && getFieldsFromAPI.fullCard().indexOf(data.name) !== -1) {
      if ((data.name === 'managementFee' || data.name === 'maintenanceFee') && (!price.showPrice || cardsData.cardMode.isUnavailable))
        return;

      return data;
    } else if (card === 'search-item' && infopointsToShowInSearchItem().includes(data.name)) {
      if ((data.name === 'managementFee' || data.name === 'maintenanceFee') && (!price.showPrice || cardsData.cardMode.isUnavailable))
        return;

      return data;
    }
  });

  const decimalOptions = config.features.apartments?.decimalOptions;
  const decimalOptionsFieldsToApply = getFieldsToApply(decimalOptions);

  infoPointsData.forEach(data => {
    let value;

    data.exceptions
      ? value = data.exceptions[data.data]
      : value = data.data;

    if (data.name === 'parkings' && Array.isArray(value))
        value = value.length;

    if (data.name === 'storages' && Array.isArray(value)) {
      const valueCopy = [ ...value ];
      value = 0;
      valueCopy.forEach(item => {
        value += item.size;
      });
    }

    if (parseInt(value) === 0)
      return;

    if (decimalOptionsFieldsToApply.includes(data.name)) {
      decimalOptions[data.name] === 'show' ?
        value = parseFloat(value).toFixed(1):
        value = parseFloat(value).toFixed(0);
    }

    if(!isNaN(value))
      value = value.toLocaleString();

    const {contentSubtext, cardModelName, cardModelNameText} =
      createInfoPointsBlockElements(card, infoPointsBlock, value, data.name);

    cardModelNameText.innerHtml(isNumeric(value) ? numberWithCommas(value) : changeLangToCurrent(value));
    cardModelName.classList.add(data.icon);

    switch (data.name) {
      case 'area':
      case 'balcony size':
      case 'roof balcony size':
      case 'covered balcony size':
      case 'basement size':
      case 'garden size':
      case 'storages':
        applyRulesForArea(contentSubtext);
        break;
      case 'accessible':
      case 'tenantPrice':
      case 'treatmentRoom':
        applyAccessibleOrTreatmentRoomRules(cardModelNameText);
        break;
      case 'exposure':
        applyExposureRules(cardModelNameText, value, card, cardModelName);
        break;
      case 'propPricePerSqm':
      case 'managementFee':
      case 'maintenanceFee':
        applyRulesForPrice(contentSubtext);
        break;
    }
  });
}

function infopointsToShowInSearchItem() {
  const arrayOfSearchResultsFields = config.features.search.searchSortState.map(element => element.type);
  const arrayOfInfopoints = getFieldsFromAPI.fullCard();

  setCommonFieldNames(arrayOfSearchResultsFields);

  return arrayOfInfopoints.filter(x => !arrayOfSearchResultsFields.includes(x));
}

function setCommonFieldNames(arrayOfUncommonNames) {
  const dictionaryOfDifference = {
    "facing": "exposure",
    "roomNum": "bedrooms",
    "totalSpace": "area",
    "balconySize": "balcony size",
    "roofBalconySize": "roof balcony size",
    "coveredBalconySize": "covered balcony size",
    "basementSize": "basement size"
  };

  for (const key in dictionaryOfDifference) {
    if (arrayOfUncommonNames.indexOf(key) !== -1)
      arrayOfUncommonNames.splice(arrayOfUncommonNames.indexOf(key), 1, dictionaryOfDifference[key]);
  }
}

const createInfoPointsBlockElements = (card, infoPointsBlock, value, name) => {
  const cardContentBlock = new BaseElement()
    .addClass(`${card}-card__info-points-block`, 'card__info-points-block')
    .appendTo(infoPointsBlock)
    .DOMElement;
  const cardContentWrapper = new BaseElement()
    .addClass(`${card}-card__info-points-wrapper`, 'card__info-points-block-wrapper')
    .appendTo(cardContentBlock)
    .DOMElement;
  const cardModelName = new BaseElement()
    .addClass(`${card}-card__info-points-block_data`, 'card__info-points-block_data')
    .appendTo(cardContentWrapper)
    .DOMElement;
  const cardModelTextWrapper = new BaseElement()
    .addClass(`${card}-card__info-points-block_data-wrapper`, 'card__info-points-block_data-wrapper')
    .addAttribute('dir', 'ltr')
    .appendTo(cardModelName)
    .DOMElement;

  const cardModelNameText = new BaseElement('span')
    .addClass(
        `${card}-card__info-points-block_data_text`,
        'card__info-points-block_data_text',
        isNumeric(value) ? 'translate-number' : 'language-string')
    .appendTo(cardModelTextWrapper)
    .addAttribute('data-dictionary', value);
  setDirectionForText(value, cardModelNameText.DOMElement);
  const contentSubtext = new BaseElement()
    .addClass(`${card}-card__info-points-block_subtitle`, 'card__info-points-block_subtitle')
    .appendTo(cardContentWrapper)
    .DOMElement;
  contentSubtext.innerHTML += `
    <span class="language-string" data-dictionary="${name}">
        ${changeLangToCurrent(name).toLowerCase()}
    </span>`;

  return {
    cardContentBlock,
    cardContentWrapper,
    cardModelName,
    cardModelTextWrapper,
    cardModelNameText,
    contentSubtext
  };
}

const getFieldsToApply = (decimalOptions) => {
  const decimalOptionsFieldsToApply = [];
  for (let key in decimalOptions) {
    decimalOptionsFieldsToApply.push(key);
  }

  return decimalOptionsFieldsToApply;
}

const setDirectionForText = (value, cardModelNameText) => {
  const regExp = /([A-Za-z])\w+/g;
  if (regExp.test(value))
    cardModelNameText.style.direction = "ltr";
}

const applyRulesForArea = (contentSubtext) => {
  const measurement = config.localization.area ? config.localization.area : "m2";
  contentSubtext.innerHTML += `<span>,</span>`;
  const measurementTag = new BaseElement('span')
    .addClass('language-string', 'card__info-points-block_subtitle-measurement', 'meters')
    .addAttribute('data-dictionary', measurement)
    .appendTo(contentSubtext)
    .DOMElement;
  measurementTag.innerHTML += changeLangToCurrent(measurement);
}

const applyRulesForPrice = (contentSubtext) => {
  const currencyLocal = config.localization.currencyLabel;
  contentSubtext.innerText = contentSubtext.innerText + ',';
  const measurementTag = new BaseElement('span')
      .addClass('language-string', 'card__info-points-block_subtitle-measurement', 'currency')
      .addAttribute('data-dictionary', currencyLocal)
      .appendTo(contentSubtext)
      .DOMElement;
  measurementTag.innerHTML += changeLangToCurrent(currencyLocal);
}

const applyAccessibleOrTreatmentRoomRules = (cardModelNameText) => {
  cardModelNameText
    .addClass('icon-check-mark')
    .removeClass('language-string', 'translate-number')
    .deleteAttribute('data-dictionary')
    .innerHtml('');
}

const applyExposureRules = (cardModelNameText, value, card, cardModelName) => {
  const dataArray = value;
  const dictionary= facingDictionary();

  if (dataArray.length === 0) {
    cardModelName.closest(`.${card}-card__info-points-block`).remove();
    return;
  }

  cardModelNameText.remove();

  dataArray.forEach(element => {
    for (let key in dictionary) {
      if (element === key) {
        new BaseElement('span')
          .addClass(
            `${card}-card__info-points-block_data_text`,
            'card__info-points-block_data_text',
            'language-string'
          )
          .addAttribute('data-dictionary', dictionary[key].en + 'Short')
          .innerHtml(changeLangToCurrent(dictionary[key].en + 'Short'))
          .appendTo(cardModelName);
      }
    }
  });
}

export const addFavoritesBlock = (object, cardBox, card) => {
  if (object.status !== "Available")
    return;

  const favoriteCheckboxBlock = new BaseElement()
    .addClass(`${card}-card__favorite`, 'card__favorite', 'options-item', 'favorite-button')
    .appendTo(cardBox)
    .DOMElement;
  new BaseElement('input')
    .addClass(`${card}-card__favorite-checkbox`, 'card__favorite-checkbox')
    .addAttribute('type', 'checkbox')
    .addAttribute('id', `favorite-check-id__${card}`)
    .appendTo(favoriteCheckboxBlock);
  const favoriteLabel = new BaseElement('label')
    .addClass(`${card}-card__favorite-label`, 'card__favorite-label','icon-unselected')
    .addAttribute('for', `favorite-check-id__${card}`)
    .event('click', (e) => {
      e.stopPropagation();
      handleFavoriteLogic(e, 'cardClick');
    })
    .appendTo(favoriteCheckboxBlock)
    .DOMElement;

  if (!isMobile) {
    favoriteLabel.classList.add('icon--lord-unselected');
    favoriteLabel.classList.remove('icon-unselected');
    let colors;
    if (isMobile && card === CardTypes.Options) {
      colors = 'primary:#ffffff,secondary:#ffffff'
    } else if (isMobile && card === CardTypes.MobileCard) {
      colors = 'primary:#000000,secondary:#000000'
    } else {
      colors = 'primary:#ff0000,secondary:#ff0000'
    }
  
    setLordIcon('favorite', favoriteLabel, {
      trigger: 'hover',
      stroke: 90,
      colors: colors
    });
  }
 

  // let secondFavorite;
  // if (card === CardTypes.MobileCard) {
  //   secondFavorite = new BaseElement('label')
  //       .addClass(`${card}-card__favorite-label`, `${card}-card__favorite-label--inverted`, 'card__favorite-label', 'icon--lord-unselected')
  //       .addAttribute('for', `favorite-check-id__${card}`)
  //       .event('click', (e) => {
  //         e.stopPropagation();
  //         handleFavoriteLogic(e, 'cardClick');
  //       })
  //       .appendTo(favoriteCheckboxBlock)
  //       .DOMElement;
  //
  //   setLordIcon('favorite', secondFavorite, {
  //     trigger: 'hover',
  //     stroke: 90,
  //     colors: 'primary:#ffffff,secondary:#ffffff'
  //   });
  // }

  const isInFavorite = getObjectFromLocalStorage(object.engineId);
  if (isInFavorite) {
    if (favoriteLabel.classList.contains('icon--lord-unselected')) {
      favoriteLabel.classList.remove('icon--lord-unselected');
    }
    if (favoriteLabel.classList.contains('icon-unselected')) {
      favoriteLabel.classList.remove('icon-unselected');
    }
    favoriteLabel.classList.add('icon-favorite_selected');
    // if (card === CardTypes.MobileCard) {
    //   secondFavorite.classList.remove('icon--lord-unselected');
    //   secondFavorite.classList.add('icon-favorite_selected');
    // }
  }
}

export function addTechnicalSpecifications(...props) {
  if (!settingsData.specifications) return;
  const [object, cardBox, card, settings] = props;
  const specsBlock = new BaseElement()
    .addClass(`${card}-card__specifications`, 'card__specifications');

  new BaseElement()
    .addClass('specifications__title', 'language-string')
    .addAttribute('data-dictionary', 'Technical specifications')
    .innerHtml(changeLangToCurrent('Technical specifications'))
    .appendTo(specsBlock.DOMElement);
  
  const specsData = settingsData.specifications.sort((prev,next) => prev.order - next.order);
  const modelName = object?.modelName;
  const bmbyPropID = String(object?.bmbyPropID);
  const currLang = getCurrentLang();

  specsData.forEach((category, categoryIndex) => {
    if (category.items.length === 0) return;



    const specsCategory = new BaseElement()
      .addClass('specifications__category')
      .addAttribute('categoryId', category.categoryId)
      .addAttribute('state', categoryIndex === 0 ? 'expanded' : 'collapsed')
      .event('click', (e) => {
        e.stopPropagation();
        const element = e.target.closest('.specifications__category');
        const state = element.getAttribute('state');
        if (state === 'expanded') {
          element.setAttribute('state', 'collapsed');
        }else {
          element.setAttribute('state', 'expanded');
        }
      })
      .appendTo(specsBlock.DOMElement);
    const specsHeader = new BaseElement()
      .addClass('specifications__header')
      .appendTo(specsCategory.DOMElement);
    new BaseElement('span')
      .addClass('specifications__header-name')
      .innerHtml(category.name.find(elem => elem.lang === currLang).value)
      .appendTo(specsHeader.DOMElement);
    new BaseElement('span')
      .addClass('specifications__header-checker', 'icon-down2')
      .appendTo(specsHeader.DOMElement);
    const specsList = new BaseElement('ul')
      .addClass('specifications__list')
      .appendTo(specsCategory.DOMElement);

    category.items.forEach((item, itemIndex) => {
      if (item.models) {
        if (item.models.length !== 0 && !item.models.includes(modelName)) {
          return;
        }
      }else if (item.props) {
        if (item.props.length !== 0 && !item.props.includes(bmbyPropID)) {
          return;
        }
      }
      new BaseElement('il')
        .addClass('specifications__item')
        .addAttribute('itemIndex', itemIndex)
        .innerHtml(item.text.find(elem => elem.lang === currLang).value)
        .appendTo(specsList.DOMElement);
    });
    if (specsList.DOMElement.children.length === 0) {
      specsCategory.remove();
    }
  });
  if (specsBlock.DOMElement.children.length > 1) {
    specsBlock.appendTo(cardBox);
  }
}

export function updateLangTechnicalSpecifications() {
  const categoryBlockArray = document.querySelectorAll('.specifications__category');
  if (!categoryBlockArray) return;
  const currLang = getCurrentLang();
  categoryBlockArray.forEach(categoryBlock => {
    const categoryId = categoryBlock.getAttribute('categoryId');
    const category = settingsData.specifications?.find(elem => elem.categoryId === categoryId);
    const headerNameBlock = categoryBlock.querySelector('.specifications__header-name');
    headerNameBlock.textContent = category.name.find(elem => elem.lang === currLang).value;
    const itemBlockArray = categoryBlock.querySelectorAll('.specifications__item');
    itemBlockArray.forEach(itemBlock => {
      const itemIndex = itemBlock.getAttribute('itemIndex');
      itemBlock.textContent = category.items[itemIndex].text.find(elem => elem.lang === currLang).value;
    });
  });
}

export function addAmenitiesOfBuilding(currentCardBoxDataElement) {
  return;
  if (!Amenities.amenitiesArray.length)
    return;

  const rootElement = new BaseElement()
      .addClass(`${CardTypes.Options}-card__amenities`)
      .appendTo(currentCardBoxDataElement);
  new BaseElement('h4')
      .addClass(`${CardTypes.Options}-card__amenities-title`, 'language-string')
      .setAttributes({'data-dictionary': 'Amenities'})
      .innerHtml(changeLangToCurrent('Amenities'))
      .appendTo(rootElement.DOMElement);
  const wrapper = new BaseElement()
      .addClass(`${CardTypes.Options}-card__amenities-wrapper`)
      .appendTo(rootElement.DOMElement);

  Amenities.amenitiesArray.forEach(amenity => {
    amenity.elementForCard.appendTo(wrapper.DOMElement);
  });
}
